import { mapStateToControlProps, rankWith } from '@jsonforms/core';
import { html } from '@microsoft/fast-element';
import { isOneOfNumber } from '../testers/isOneOfNumber';
import { NUMBER_CONTROL_RANK } from './RenderersRanks';
export const NumberControlRendererTemplate = (prefix = 'zero') => html `
  <template>
    <control-wrapper
      :control=${(x) => x.control}
      :touched=${(x) => x.touched}
      ?submitted=${(x) => x.submitted}
    >
      <${prefix}-number-field
      withFormatting=${(x) => { var _a; return (((_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.withoutFormatting) ? false : true); }}
        :options=${(x) => { var _a; return (_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.formatOptions; }}
        :value=${(x) => (x.control.data === undefined ? '' : String(x.control.data))}
        @change=${(x, c) => {
    const value = parseFloat(c.event.target.value);
    return x.control.handleChange(x.control.path, !isNaN(value) ? value : undefined);
}}
        placeholder=${(x) => x.control.uischema.placeholder || x.control.label}
        id=${(x) => x.control.path}
        data-test-id=${(x) => x.control.path}
        ?required=${(x) => x.control.required}
        ?disabled=${(x) => !x.control.enabled}
        hideStep
        @blur=${(x) => x.onBlur()}
        style="width: 100%"
      ></${prefix}-number-field>
    </control-wrapper>
  </template>
`;
export const NumberControlRendererEntry = {
    renderer: html `
    ${(x) => NumberControlRendererTemplate(x.jsonforms.prefix)}
  `,
    tester: rankWith(NUMBER_CONTROL_RANK, isOneOfNumber),
    mapper: mapStateToControlProps,
};
